import { render } from "./IconUserRank.vue?vue&type=template&id=1ee001b3&scoped=true&ts=true"
import script from "./IconUserRank.vue?vue&type=script&lang=ts"
export * from "./IconUserRank.vue?vue&type=script&lang=ts"

import "./IconUserRank.vue?vue&type=style&index=0&id=1ee001b3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee001b3"]])

export default __exports__